<div class="base-datos" style="margin-top: -60px;">

    <div class="movil-bd-title">
        <p class="movil-db-seccion"><span class="fa fa-angle-left"></span>&nbsp;&nbsp;<span [routerLink]="['/base-de-datos']" >Regresar</span></p>

        <h2>Base de Datos </h2>

        <div class="dropdown w-100 bgBlanco d-block d-xl-none">
            <button class="btn dropdown-toggle dis-flex space-b w-100 p-1 px14" type="button" id="dmDistrito" (click)="openMenuType()">
            &nbsp;
                {{ selectedOptionLabel }}
                <i class="mcad mcad-drop-down_flecha mr-1" aria-hidden="true"></i>
            </button>
        </div>
    </div>

    <div *ngIf="selectedOption == 0" class="movil-card" style="margin-top: -30px; padding: 16px;">
        <div class="subtitulo padding-b-50 p-l">
            - Definición -
        </div>
        <img width="90%" src="../../../../../assets/img/basededatos/movil-fondo-definicion.svg" style="margin-top: 30px;"/>

        <div class="subtitulo padding-b-50 p-l" style="margin-top: 30px;">
            - Base de Datos y utilidad -
        </div>       
        <div style="text-align: justify; margin-top: 16px; margin-bottom: 30px;">
            La <span class="font-bold">Base de Datos</span> se refiere al conjunto de información perteneciente al <span class="font-bold">Programa de Resultados Electorales 
                Preliminares</span>(PREP), ordenada de forma sistemática para su descarga y análisis.​ Es actualizada conforme al último corte. Permite realizar distintas operaciones ya que incluye datos numéricos, alfanuméricos y cronológicos.​
        </div>
        
    </div>


    <div *ngIf="selectedOption == 1" class="movil-card" style="margin-top: -30px;">
        <div style="padding: 16px;">
            <div class="subtitulo padding-b-50 p-l">
                - Contenido -
            </div>
            <img width="90%" src="../../../../../assets/img/basededatos/movil_contenido.svg" style="margin-top: 30px;"/>
        </div>
        
        <div class="bgAzul py-5 txBlanco bottom-radius" style="margin-top: 30px;">
            <div class="col-12 col-xl-5 p-l">
                <div class="padding-b-30 mobile-parrafo">
                    Se trata de un archivo comprimido global con <br>
                    una nomenclatura que indica el <span class="font-bold">año</span>, <span class="font-bold">mes</span>, <br>
                    <span class="font-bold">día</span> y <span class="font-bold">hora del corte</span>; por ejemplo: <span class="font-bold">20240602_2100_PREP</span>, es de extensión <span class="font-bold">.zip</span><br>
                    y se encuentra organizado en carpetas <br>
                    por tipo de elección:
                </div>
                <div class="padding-b-30 mobile-parrafo">
                    <p *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura')" class="single-option"><i class="fas fa-circle"></i> 20240602_2100_PREP_GUB<span class="font-bold">.zip</span></p>
                    <p class="single-option"><i class="fas fa-circle"></i> 20240602_2100_DIP_LOC<span class="font-bold">.zip</span></p>
                    <p class="single-option"><i class="fas fa-circle"></i> 20240602_2100_AYUN<span class="font-bold">.zip</span></p>
                    <p *ngIf="habilitar_label_regidurias" class="single-option"><i class="fas fa-circle"></i> 20240602_2100_PREP_REG<span class="font-bold">.zip</span></p>
                </div>
                <div class="mobile-parrafo">
                    Cada una de ellas contiene tres tipos de <br>
                    archivos:los resultados y el catálogo de <br>
                    candidaturas ambos en formato <span class="font-bold">csv</span>, por <br>
                    último, el archivo con la descripción de <br>
                    las variables en formato  <span class="font-bold">.txt</span>.
                </div>
            </div>
            <div class="col-12 col-xl-7 p-l">
                <img *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura') && habilitar_label_regidurias" style="width: 100%;" src="./assets/img/basededatos/carpetaarchivos.png" alt="">
                <img *ngIf="!globalService.arrContiendasActivasStr.includes('gubernatura') && habilitar_label_regidurias" style="width: 100%;" src="./assets/img/basededatos/carpetaarchivos-nogob.png" alt="">
                <img *ngIf="!globalService.arrContiendasActivasStr.includes('gubernatura') && !habilitar_label_regidurias" style="width: 100%;" src="./assets/img/basededatos/carpetaarchivos-noreg.png" alt="">
            </div>
            <div class="col-12 p-l">
                
                <div class="padding-b-10 mobile-parrafo">
                    <p class="font-bold">Archivos de resultados:</p>
                </div>
                <div class="padding-b-20 mobile-parrafo">
                    <p *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura')" class="single-option"><i class="fas fa-circle"></i> GUB_2024<span class="font-bold">.csv</span></p>
                    <p class="single-option"><i class="fas fa-circle"></i> DIP_LOC_2024<span class="font-bold">.csv</span></p>
                    <p class="single-option"><i class="fas fa-circle"></i> AYUN_2024<span class="font-bold">.csv</span></p>
                    <p *ngIf="habilitar_label_regidurias" class="single-option"><i class="fas fa-circle"></i> REG_2024<span class="font-bold">.csv</span></p>
                </div>
                <div class="padding-b-30 mobile-parrafo">
                    Contienen los resultados de la votación por acta a nivel
                    distrital o municipal. Muestran el número de votos recibidos por <br>
                    cada uno de los Partidos Políticos, combinaciones de <br>
                    coalición, Candidaturas Independientes, candidaturas <br>
                    no regristradas y votos nulos.
                </div>
                <div class="padding-b-10 mobile-parrafo">
                    <p class="font-bold">Catálogos de candidaturas:</p>
                </div>
                <div class="padding-b-20 mobile-parrafo">
                    <p *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura')" class="single-option"><i class="fas fa-circle"></i> GUB_CANDIDATURAS_2024<span class="font-bold">.csv</span></p>
                    <p class="single-option"><i class="fas fa-circle"></i> DIP_LOC_CANDIDATURAS_2024<span class="font-bold">.csv</span></p>
                    <p class="single-option"><i class="fas fa-circle"></i> AYUN_CANDIDATURAS_2024<span class="font-bold">.csv</span></p>
                    <p *ngIf="habilitar_label_regidurias" class="single-option"><i class="fas fa-circle"></i> REG_CANDIDATURAS_2024<span class="font-bold">.csv</span></p>
                </div>
                <div class="padding-b-30 mobile-parrafo">
                    Estos documentos contienen el listado de <br>
                    candidaturas por Partido Político y Candidaturas <br>
                    Independientes que participan en las elecciones locales en <br>
                    cada uno de los cargos.
                </div>
                <div class="padding-b-10 mobile-parrafo">
                    <p class="font-bold">Descripción de variables:</p>
                </div>
                <div class="padding-b-20 mobile-parrafo">
                    <p class="single-option"><i class="fas fa-circle"></i> <span class="font-bold">LEEME.txt</span></p>
                </div>
                <div class="padding-b-60 padding-l-50 mobile-parrafo">
                    Describe a detalle cada uno de los campos que <br>
                    forman los archivos de resultados y candidaturas
                </div>
            </div>
            <div class="col-12 p-l movil-nota">
                <p>*Nota: Recuerda, al realizar la descarga, el nombre del archivo <span class="font-bold">.zip</span> se complementará con la <span class="font-bold">fecha</span>, comenzando por el <span class="font-bold">año</span>, <span class="font-bold">mes</span>, y <span class="font-bold">día</span>, así como la hora <br>
                respecto al <span class="font-bold">último corte</span>, conservando siempre esta estructura: AAAAMMDD_HHMM_PREP.zip</p>
            </div>
        </div>        
    </div>

    <div *ngIf="selectedOption == 1" class="movil-card descargar" style="margin-top: 30px;">
        <div style="padding: 16px;">
            <div class="subtitulo padding-b-50 p-l">
                - Descargar -
            </div>
            <div style="background-color: white; border-radius: 8px; margin-top: 8px;">
                <img width="90%" src="../../../../../assets/img/basededatos/movil-descargar.png" style="margin-top: 30px;"/>
            </div>

            <div class="row" style="margin-top: 30px;">
                <div class="col-12 col-lg-3">
                    <div class="item dis-flex align-s">
                        <div class="numero-descarga dis-flex justify-s padding-r-10 font-bold">
                            1
                        </div>
                        <div class="contenido dis-flex flex-col align-s fs-16">
                            <span class="font-bold" style="text-decoration: underline;">Descarga</span> Haz clic en el botón Base de datos​ para iniciar la  descarga del archivo comprimido.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-1 ">
                    <img class="movil-img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                </div>
                <div class="col-12 col-lg-3">
                    <div class="item dis-flex align-s">
                        <div class="numero-descarga dis-flex justify-s padding-r-10 font-bold">
                            2
                        </div>
                        <div class="contenido dis-flex flex-col align-s  fs-16">
                            <span class="font-bold" style="text-decoration: underline;">Localiza</span> Encuentra el archivo en<br> la carpeta de descargas.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-1">
                    <img class="movil-img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                </div>
                <div class="col-12 col-lg-2">
                    <div class="item dis-flex align-s">
                        <div class="numero-descarga dis-flex justify-s padding-r-10 font-bold">
                            3
                        </div>
                        <div class="contenido dis-flex flex-col align-s fs-16">
                            <span class="font-bold" style="text-decoration: underline;">Selecciona</span> el archivo, haciendo clic sobre él
                        </div>
                    </div>
                </div>
            </div>
        </div>
             
    </div>


    <div *ngIf="selectedOption == 1" class="movil-card" style="margin-top: 30px;">
        <div style="padding: 16px;">
            <div class="subtitulo padding-b-50 p-l">
                - Descomprimir -
            </div>
            <img width="90%" src="../../../../../assets/img/basededatos/movil-descomprimir.svg" style="margin-top: 30px;"/>
        </div>
        
        <div class="bgAzul py-5 txBlanco bottom-radius" style="margin-top: 30px;text-align: justify; padding-left: 16px; padding-right: 16px;">
            <p>
                En el caso de la mayoría de los dispositivos móviles, simplemente toca el archivo seleccionado y busca la opción de “Descomprimir” en el menú emergente. Si no encuentras esta opción, puedes utilizar aplicaciones de terceros disponibles en la tienda de aplicaciones para descomprimir el archivo.
            </p>
        </div>        
    </div>

    <div *ngIf="selectedOption == 1" class="movil-card" style="margin-top: 30px;">
        <div style="padding: 16px;">
            <div class="subtitulo padding-b-50 p-l">
                - Abrir -
            </div>
            <img width="90%" src="../../../../../assets/img/basededatos/movil-abrir.svg" style="margin-top: 30px;"/>
        </div>
        
        <div class="row" style="margin: 30px 16px;">
            <div class="col-12 col-lg-3">
                <div class="contenido fs-16" style="text-align: justify;">
                    <span class="font-bold">Los archivos .csv</span> <br> ​Contienen información organizada en filas y columnas. Puedes visualizar y trabajar con estos archivos en aplicaciones de hojas de cálculo disponibles para dispositivos móviles, como Excel, Google Sheets, Numbers, etc.
                </div>
            </div>
            <div class="col-12 col-lg-1 ">
                <img class="movil-img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
            </div>
            <div class="col-12 col-lg-3">
                <div class="contenido fs-16" style="text-align: justify;">
                    <span class="font-bold">Archivo leeme.txt</span> <br>Al tocarlo, se abrirá la aplicación correspondiente según tu sistema operativo móvil; por ejemplo, en Android se abrirá en una aplicación de notas de texto y en iOS en la aplicación Notas.
                </div>
            </div>
        </div>
        
    </div>

    <div *ngIf="selectedOption == 2" class="movil-card  {{ !themeService.isDarkTheme() ? 'bgRosa' : 'bgWhite txBlanco'}}" style="margin-top: -30px;">
        <div style="padding: 16px;">
            <div class="subtitulo padding-b-50 p-l">
                - Estructura de los datos -
            </div>
        </div>

        <div class="row" style="padding: 16px;">
            <div class="col-12 col-md-8 p-l">
                <div class="padding-40 padding-t-20 padding-b-20 mobile-parrafo brackets">
                    <div class="bracket-content">
                        Si deseas una revisión detallada de las variables de la Base de Datos, puedes <u>descargar el Manual Interpretación de la Base de Datos PREP,</u> actualizado en junio de 2024.
                    </div>
                </div>
            </div>
            <div class="col-12 p-l">
                <div class="padding-b-20 mobile-parrafo">
                    Los elementos que conforman el archivo de la Base de Datos son:
                </div>
                <div>
                    <div class="row custom-filas">
                        <div class="col-12 padding-b-20">
                            <div class="fila-titulo font-bold">Fila 1</div>
                            <div class="fila mobile-parrafo">Tipo de elección. Ya sea {{ existeGobernatura ? 'Gubernatura, ' : ''}} {{ (existeGobernatura && (existeDiputaciones && !existeAyuntamientos) || (existeAyuntamientos && !existeDiputaciones)) ? 'o' :'' }} {{existeDiputaciones ? 'Diputaciones' : ''}} {{( (existeGobernatura || existeDiputaciones) && existeAyuntamientos) ? 'o' : ''}} {{existeAyuntamientos ? 'Ayuntamientos' : ''}}.</div>
                        </div>
                        <div class="col-12 padding-b-20">
                            <div class="row">
                                <div class="col-12 col-lg-7">
                                    <div class="fila-titulo font-bold">
                                        Fila 2
                                    </div>
                                    <div class="fila mobile-parrafo">
                                        <span class="font-bold">Fecha y hora del corte de información</span> con el formato <span class="font-bold">DD/MM/AAAA HH:MM.</span>
                                        <!-- <br> --> Se especifica la hora en formato de 24 horas, Tiempo del estado de {{config.estado}}.
                                        <!-- <div class="px11 my-2 px-2 py-3 bordes-laterales">
                                            <div class="supIzq"></div>
                                            <div class="supDer"></div>
                                            <div class="infIzq"></div>
                                            <div class="infDer"></div>
                                            <p class="p-0 m-0">
                                                Si deseas una revisión detallada de las variables de la Base de Datos descarga el <span class="underline">Manual Interpretación de la Base de Datos PREP, junio 2023.</span>
                                            </p>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="col-12 col-lg-5">
                                    <img *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura')" class="img-fila2" src="./assets/img/basededatos/fila2.png" alt="fila2">
                                    <img *ngIf="!globalService.arrContiendasActivasStr.includes('gubernatura')" class="img-fila2" src="./assets/img/basededatos/fila2-nogob.png" alt="fila2">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 padding-b-20">
                            <div class="fila-titulo font-bold">Fila 3</div>
                            <div class="fila mobile-parrafo">
                                Variables del resumen de la base de datos:​
                            </div>
                        </div>
                        <div class="col-12 padding-b-20">
                            <div class="row">
                                <div class="col-12 col-lg-7" style="padding-top: 20px;">
                                    <img class="img-fila4" src="./assets/img/basededatos/fila4.svg" alt="fila4">
                                    <p class="img-description">Conoce más sobre estos términos y su significado en el <u>Centro de Ayuda</u></p>
                                </div>
                                <div class="col-12 col-lg-1 d-none d-lg-block">
                                    <img class="img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                                </div>
                                <div class="col-12 col-lg-4 mobile-parrafo font-bold">
                                    <ul>
                                        <li>Actas esperadas​</li>
                                        <li>Actas registradas</li>
                                        <li>​Actas fuera de catálogo​</li>
                                        <li>​Actas capturadas</li>
                                        <li>Porcentaje de actas capturadas</li>
                                        <li>Actas contabilizadas</li>
                                        <li>Porcentaje de actas contabilizadas</li>
                                        <li>Porcentaje de inconsistencias en Actas no contabilizadas</li>
                                        <li>Lista Nominal de las Casillas con actas contabilizadas</li>
                                        <li *ngIf="!config?.hide_especiales">​Total de votos con Casillas Especiales</li>
                                        <li *ngIf="!config?.hide_especiales">​Total de votos sin Casillas Especiales​</li>
                                        <li>Porcentaje de Participación Ciudadana</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-7 padding-b-20">
                            <div class="fila-titulo font-bold">Fila 4</div>
                            <div class="fila mobile-parrafo">
                                Contenido de las variables del resumen de la Base de Datos correspondientes a la fila 3.
                            </div>
                        </div>
                        <div class="col-12 col-lg-7 padding-b-20">
                            <div class="fila-titulo font-bold">Fila 5</div>
                            <div class="fila mobile-parrafo">
                                Vacía para separar las variables de los datos de las Casillas.
                            </div>
                        </div>

                        <div class="col-12 padding-b-20">
                            <div class="row">
                                <div class="col-12 padding-b-40">
                                    <div class="fila-titulo font-bold ">Fila 6</div>
                                    <div class="fila mobile-parrafo">
                                        Indica las variables de los resultados de votación, las cuales se pueden agrupar en​:
                                    </div>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <img class="img-fila6" src="./assets/img/basededatos/fila6.svg" alt="fila6">
                                </div>
                                <div class="col-12 col-lg-1 d-none d-lg-block">
                                    <img class="img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                                </div>
                                <div class="col-12 col-lg-4 mobile-parrafo font-bold">
                                    <ul>
                                        <li>Clave Casilla</li>
                                        <li>Clave acta</li>
                                        <li>ID Entidad</li>
                                        <li>Entidad</li>
                                        <li>ID Distrito Federal</li>
                                        <li>Distrito Federal</li>
                                        <li>Sección</li>
                                        <li>ID Casilla</li>
                                        <li>Tipo Casilla</li>
                                        <li>Ext contigua</li>
                                        <li>Ubicación de la Casilla</li>
                                        <li>Totales derivados de la votación</li>
                                        <li>Resultados de la votación</li>
                                        <li>Estatus, traslado y seguridad de las actas</li>
                                        <li>Procesamiento de las actas</li>
                                        <li>Proceso de digitalización</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="fila-titulo font-bold">Fila 7</div>
                            <div class="fila mobile-parrafo">
                                A partir de esta fila se indican los datos correspondientes a cada Acta.
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12 col-lg-7">
                                    <img class="img-fila7" src="./assets/img/basededatos/fila7.svg" alt="fila7">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>

    <div *ngIf="selectedOption == 2" class="movil-card bgAzul txBlanco" style="margin-top: 30px;">
        <div class="subtitulo padding-b-50 p-l" style="padding: 16px;">
            - Autenticidad -
        </div>

        <div class="row" style="padding: 0 16px 16px 16px;">
            <div class="col-12">
                <div class=" mobile-parrafo">
                    Para validar la autenticidad de la imagen del Acta de tu casilla, puedes utilizar un software lector de código único de imagen de la siguiente forma.​​
                </div>
            </div>

            <div class="offset-3 col-6 padding-b-20">
                <img class="img-descargar" src="./assets/img/basededatos/autenticidad-1.gif" alt="autenticidad-1">
            </div>

            <div class="col-12 col-lg-3 mobile-parrafo">
                <p class="font-bold">
                    Código HASH 
                </p>
                <p>
                    &#8226; Es una serie de caracteres únicos asociada al archivo de la imagen digitalizada del Acta de Escrutinio y Cómputo (AEC). ​
                </p>
            </div>

            <div class="col-12 col-lg-1 ">
                <img class="movil-img-descargar img-alt-color" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
            </div>

            <div class="col-12 col-lg-3 mobile-parrafo">
                <p class="font-bold">
                    Verifica la imagen
                </p>
                <p>
                    &#8226; Busca en internet algún lector de códigos para comprobar si la imagen del AEC fue manipulada con editores de imágenes, si se intentó alterar el archivo y la legitimidad de la información.
                </p>
            </div>

            <div class="col-12 col-lg-1 ">
                <img class="movil-img-descargar img-alt-color" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
            </div>

            <div class="col-12 col-lg-3 mobile-parrafo">
                <p class="font-bold">
                    Valida
                </p>
                <p>
                    &#8226; Una vez localizado o descargado el lector de código de integridad, selecciona la opción de lectura HASH 256, ya que es el utilizado por el PREP para validar que el archivo no fue alterado.
                </p>
            </div>

            <div class="col-12 col-lg-1 ">
                <img class="movil-img-descargar img-alt-color" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
            </div>

            <div class="col-12 col-lg-3 mobile-parrafo">
                <p class="font-bold">
                    Ubica​ el Acta
                </p>
                <p>
                    &#8226; Encuentra y descarga el acta de la Casilla que deseas verificar desde el PREP a tu computadora.
                </p>
            </div>

            <div class="col-12 col-lg-1 ">
                <img class="movil-img-descargar img-alt-color" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
            </div>

            <div class="col-12 col-lg-3 mobile-parrafo">
                <p class="font-bold">
                    Genera el Código HASH​​​
                </p>
                <p>
                    &#8226; Abre el lector del código de integridad HASH 256 de tu preferencia y sube el archivo de la <u>imagen del Acta</u>.
                </p>
                <p>
                    ​&#8226; Elige la secuencia: File-Select File (Archivo-Seleccionar Archivo).​
                </p>
                <p>
                    ​&#8226; ​Selecciona la opción HASH 256. ​
                </p>
                <p>
                    &#8226;​ Elige el archivo y presiona abrir.​
                </p>
            </div>

            <div class="col-12 col-lg-3 mobile-parrafo">
                <p class="font-bold">
                    Copia del código
                </p>
                <p>
                    &#8226; Copia y pega el código que arroja el lector de código SHA y pégalo en la Base de Datos del PREP al lado de la columna Código_integridad.
                </p>
            </div>

            <div class="offset-3 col-6 padding-b-20">
                <img class="img-descargar" src="./assets/img/basededatos/autenticidad-4.svg" alt="autenticidad-1">
            </div>

            
            <div class="col-12 col-lg-3 mobile-parrafo">
                <p class="font-bold">
                    Compara
                </p>
                <p>
                    &#8226; Compara el código de la imagen del acta con el proporcionado por el lector de código HASH 256.<br><br>Asegúrate de que todos los caracteres coincidan, independientemente de las mayúsculas o minúsculas.
                </p>
            </div>

            <div class="offset-3 col-6 padding-b-20">
                <img class="img-descargar" src="./assets/img/basededatos/autenticidad-3.svg" alt="autenticidad-1">
            </div>

            <div class="col-12 col-lg-3 mobile-parrafo">
                <p class="font-bold">
                    Confirma que no hay alteraciones
                </p>
                <p>
                    &#8226; A través del código HASH 256 podrás identificar fácilmente si la imagen del acta fue manipulada con algún software de edición de imágenes.​
                </p>
            </div>

            <div class="offset-3 col-6 padding-b-20">
                <img class="img-descargar" src="./assets/img/basededatos/autenticidad-5.svg" alt="autenticidad-1">
            </div>

            <div class="col-12 col-lg-3 mobile-parrafo">
                <p>
                    Este proceso asegura que la imagen del acta de tu Casilla no haya sido modificada y garantiza la autenticidad de la información contenida en ella. Sigue estos pasos para asegurarte de la integridad de los resultados electorales.
                </p>
            </div>


        </div>
        
    </div>

    <!-- BOTTOM -->
    <div style="width: 100%; height: 30px;">

    </div>
    
</div>